import * as React from "react";
import "./MethodBody.scss";
import MethodSubtitle from "../MethodSubtitle/MethodSubtitle";
import MethodText from "../MethodText/MethodText";
import PropTypes from "prop-types";

const MethodBody = (props) => {
  const text = props.text;
  const subtitle = props.subtitle;
  const borderColor = props.background === "black" ? "white" : "black";
  const backgroundClass = ` method-desktop-body-background-${props.background} `;
  const containerClass = `method-desktop-body`;

  if (props.titleAbove) {
    return (
      <div className={containerClass + backgroundClass}>
        <MethodSubtitle
          hasBorder={true}
          border={borderColor}
          subtitle={subtitle}
        />
        <MethodText
          text={text}
          limitWidth={props.limitWidth}
          alignment={props.alignment}
        />
      </div>
    );
  }
  return (
    <div className={containerClass + backgroundClass}>
      <MethodText
        hasBorder={true}
        border={borderColor}
        text={text}
        limitWidth={props.limitWidth}
        alignment={props.alignment}
      />
      <MethodSubtitle subtitle={subtitle} />
    </div>
  );
};

MethodBody.propTypes = {
  text: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  limitWidth: PropTypes.string.isRequired,
  alignment: PropTypes.string.isRequired,
  titleAbove: PropTypes.bool.isRequired,
};

export default MethodBody;
